"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var width = _a.width;
            return ({
                height: "45px",
                width: width,
                borderRadius: "8px",
                position: "absolute",
                padding: "8px 12px",
                top: "20px",
                right: "32px",
                display: "flex",
                flexDirection: "column"
            });
        },
        content: function () { return ({
            width: "100%",
            marginBottom: "4px",
            display: "flex",
            justifyContent: "space-between"
        }); },
        percentComplete: function () { return ({
            fontSize: "13px",
            fontWeight: "bold"
        }); },
        divider: function () { return ({
            fontSize: "12px",
            fontWeight: 600,
            padding: "0 6px"
        }); },
        currentStatus: function () { return ({
            fontSize: "13px"
        }); },
        action: function () { return ({
            fontSize: "13px",
            fontWeight: 600
        }); },
        contentLeft: function () { return ({}); },
        contentRight: function () { return ({}); }
    });
});
